import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { passwordLengthValidator, passwordsMatchValidator } from 'src/app/shared/validators';
import { NotificationService } from '../../../shared/services/notification.service';
import { ResetPasswordViewModel } from '../../auth-models';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-interactive-access-reset-password',
  templateUrl: './interactive-access-reset-password.component.html',
  styleUrls: ['./interactive-access-reset-password.component.scss'],
  standalone: false,
})
export class InteractiveAccessResetPasswordComponent implements OnInit {
  isBusy = false;
  private token: string;
  private userId: string;
  serverErrors: string[];

  formGroup: UntypedFormGroup;

  inputType: 'text' | 'password' = 'password';
  inputTypePassCopy: 'text' | 'password' = 'password';

  constructor(
    private notificationService: NotificationService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token');
    this.userId = this.route.snapshot.paramMap.get('userId');

    this.formGroup = new UntypedFormGroup(
      {
        password: new UntypedFormControl('', { validators: [Validators.required, passwordLengthValidator] }),
        confirmedPassword: new UntypedFormControl('', { validators: [Validators.required] }),
      },
      {
        validators: [passwordsMatchValidator],
      }
    );

    if (!this.token || !this.userId) {
      this.routeToLoginPage();
    }
  }

  onSubmit() {
    if (this.formGroup.invalid) return;

    const model = this.formGroup.value as ResetPasswordViewModel;
    model.token = this.token;
    model.id = this.userId;

    this.isBusy = true;
    this.serverErrors = [];
    this.authService.interactiveAccessResetPassword(model).subscribe(
      (response) => {
        this.isBusy = false;
        if (response.succeeded) {
          this.notificationService.success('Password has been reset successfully.');
          this.routeToLoginPage();
        } else {
          this.serverErrors = response.errors.map((x) => x.description);
        }
      },
      (error) => {
        this.notificationService.error('Something went wrong! Please try again later.');
        this.isBusy = false;
      }
    );
  }

  onRevealOrHide(isVisible: boolean) {
    if (isVisible) this.inputType = 'text';
    else this.inputType = 'password';
  }

  onRevealOrHideCopy(isVisible: boolean) {
    if (isVisible) this.inputTypePassCopy = 'text';
    else this.inputTypePassCopy = 'password';
  }

  private routeToLoginPage() {
    this.router.navigateByUrl('/auth/interactive-access/login');
  }
}
